module.exports = __webpack_public_path__ + "img/背景2.2b71b6a3.jpg";